import React from 'react'

import { Text } from '../../../../../../components'

import { PMI_DROPPED_PERCENT } from '../../../../../../constants/buyerSettings'

import styles from './DownPaymentSubtext.module.scss'

const DownPaymentSubtext = () => (
  <div className={styles.downPaymentSubtext}>
    <Text element='span'>
      Down payments under {PMI_DROPPED_PERCENT}% often require PMI, increasing
      monthly costs.
    </Text>
  </div>
)

export default DownPaymentSubtext
